import { render, staticRenderFns } from "./AdsLockedOverlay.vue?vue&type=template&id=b647a314&scoped=true"
import script from "./AdsLockedOverlay.vue?vue&type=script&lang=js"
export * from "./AdsLockedOverlay.vue?vue&type=script&lang=js"
import style0 from "./AdsLockedOverlay.vue?vue&type=style&index=0&id=b647a314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b647a314",
  null
  
)

export default component.exports